<template>
    <div>
        <div 
        class="tw-overflow-hidden"
        :style="{
            height: (!loading && errors.length == 0) ? null : 0
        }">
            <form :action="formAction" method="POST" target="accept-hosted" ref="activator">
                <input type="hidden" name="token" :value="token">
            </form>

            <iframe v-show="!complete" id="accept-hosted" name="accept-hosted" width="100%" frameborder="0" scrolling="yes" :height="frameHeight" @load="onIframeLoaded">
            </iframe>
            
            <transition name="fade">
                <div v-show="complete">
                    <div class="tw-text-center tw-border-b tw-pb-4 tw-mb-4">
                        <i class="fa fa-check fa-2x text-success tw-mb-2 tw-p-2 tw-border-2 tw-border-green-600 tw-rounded-full"></i>
                        <h3 class="tw-font-bold text-success">Payment Received!</h3>
                    </div>
                    <base-loader :active="!receiptError" :overlay="false" text="Loading Your Receipt"></base-loader>
                    <p v-show="receiptError" class="alert alert-warning tw-text-center tw-mb-0">We encountered a problem displaying your receipt. A copy will be emailed to you shortly.</p>
                </div>
            </transition>
        </div>

        <base-loader :active="loading && errors.length == 0" :overlay="false"></base-loader>

        <div v-show="errors.length > 0">
            <div class="alert alert-danger tw-mb-0">{{ errors.flat().join(' ') }}</div>
        </div>
    </div>
</template>

<script>
import Echo from 'laravel-echo';

export default {
    name: "AcceptHosted",

    props: {
        paymentType: {
            type: String,
            default: "creditCard"
        },
        order: {
            type: Number
        },
        environment: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            token: null,
            refId: null,
            loading: true,
            complete: false,
            errors: [],
            receiptError: false,
            frameHeight: 0
        }
    },

    computed: {
        formAction() {
            return this.environment == 'PRODUCTION' ? 'https://accept.authorize.net/payment/payment' : 'https://test.authorize.net/payment/payment';
        }
    },

    mounted() {
        // Initialize Echo
        window.Pusher = require('pusher-js');

        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: 'pusher-key',
            wsHost: window.location.hostname,
            wsPort: 6001,
            wssPort: 6001,
            cluster: 'mt1',
            forceTLS: window.Laravel.environment == 'production',
            disableStats: true
        });

        window.Echo.connector.pusher.connection.bind('connected', () => {
            console.log('connected to websocket server');
            this.receiptError = false
        });

        window.Echo.connector.pusher.connection.bind('unavailable', () => {
            console.log('websocket server unavailable');
            this.receiptError = true;
        });

        // From the Pusher docs:
        // Channels is not supported by the browser. This implies that WebSockets are not natively available and an HTTP-based transport could not be found.
        window.Echo.connector.pusher.connection.bind('failed', () => {
            console.log('pusher failed');
            this.receiptError = true;
        });

        // Connection error
        window.Echo.connector.pusher.connection.bind('error', (error) => {
            console.log('websocket connection error');
            this.receiptError = true;
        });

        if(this.order) {
            // Generate a token for the given order
            this.getToken();
        }

        // Listen for the "token" event from the create-online-transaction component
        // This will only be used in the payment portal
        EventBus.$on('token', event => {
            console.log('Token received');

            this.loadForm(event.token, event.refId);
        })

        // Listen for messages from the iframe
        EventBus.$on('message', event => this.onMessage(event));
    },

    methods: {
        onIframeLoaded() {
            console.log('iframe');
            this.loading = false;

            if(!this.frameHeight) {
                this.frameHeight = 700;
            }
        },

        getToken() {
            this.loading = true;

            // Send a request to generate a form token for the current order
            axios.post("/api/transaction/token" , {
                order: this.order,
                "paymentType": this.paymentType
            })
            .then(response => {
                console.log(response);

                if(response.data.messages.resultCode == "Ok") {
                    // Token generation successful
                    this.loadForm(response.data.token, response.data.refId);
                } else {
                    throw new Error('Error generating token');
                }
            })
            .catch(error => {
                if(error.response.status == 422) {
                    console.error(error.message);
                    console.log(error.response);
                    console.log(error.response.data.errors);

                    this.errors = Object.values(error.response.data.errors);
                } else {
                    this.errors = ['Sorry, the payment form could not be loaded'];
                }

                this.loading = false;
            })
        },

        loadForm(token, refId) {
            // Store the token, and submit the form to load the iframe
            this.token = token;
            this.refId = refId;

            this.$nextTick(() => {
                this.$refs.activator.submit();
            });

            // Subscribe to the order channel to be notified when the order has been closed
            window.Echo.channel('transactions.' + this.refId)
            .listen('PaymentProcessed', event => {
                console.log('Payment was processed');

                // I want to find a better way to do this, but for now, redirect to a different receipt page depending on which page this component is on
                if(this.order) {
                    window.location.replace('/order/complete');
                } else {
                    window.location.replace('/transaction/receipt');
                }
            })
            .error(error => {
                console.error(error.message);
                this.receiptError = true;
            });
        },

        parseQueryString(str) {
            var vars = [];
            var arr = str.split('&');
            var pair;
            for (var i = 0; i < arr.length; i++) {
                pair = arr[i].split('=');
                vars[pair[0]] = unescape(pair[1]);
            }
            return vars;
        },

        onMessage(event) {
            let params = this.parseQueryString(event.qstr);

            switch(params.action) {
                case "resizeWindow" :
                    this.frameHeight = params.height + 20;
                    break;
                case "cancel":
                    this.token = null;
                    this.refId = null;
                    this.loading = true;
                    this.$emit('cancel');
                    break;
                case "transactResponse":
                    // Payment complete
                    console.log('payment complete');

                    this.displayIFrame = false;
                    this.complete = true;

                    break;
            }
        }
    }
}
</script>

<style>

</style>